<template>
  <div class="field-select position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
      <FieldHistoryLabelButton :field="field" :mode="mode" />
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldSelect
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldSelect
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :disableLock="disableLock"
      :calculated="calculated"
      @input="$emit('input', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldSelect
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
    />
  </div>
</template>

<script>
import EditFieldSelect from "./select/editField.vue";
import ViewFieldSelect from "./select/viewField.vue";
import FilterFieldSelect from "./select/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";
import FieldHistoryLabelButton from "../common/FieldHistoryLabelButton.vue";

export default {
  name: "FieldSelect",
  mixins: [fieldEditableByMixin],
  components: {
    FieldHistoryLabelButton,
    EditFieldSelect,
    ViewFieldSelect,
    FilterFieldSelect,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    computedFieldId() {
      return this.fieldId || `field-select-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-select {
  width: 100%;
}
</style>
